/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface EvidenceHighlight
 */
export interface EvidenceHighlight {
  /**
   *
   * @type {string}
   * @memberof EvidenceHighlight
   */
  example: string;
  /**
   *
   * @type {string}
   * @memberof EvidenceHighlight
   */
  note: string;
  /**
   *
   * @type {number}
   * @memberof EvidenceHighlight
   */
  evidenceIndex: number;
}

/**
 * Check if a given object implements the EvidenceHighlight interface.
 */
export function instanceOfEvidenceHighlight(value: object): value is EvidenceHighlight {
  if (!('example' in value) || value['example'] === undefined) return false;
  if (!('note' in value) || value['note'] === undefined) return false;
  if (!('evidenceIndex' in value) || value['evidenceIndex'] === undefined) return false;
  return true;
}

export function EvidenceHighlightFromJSON(json: any): EvidenceHighlight {
  return EvidenceHighlightFromJSONTyped(json, false);
}

export function EvidenceHighlightFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceHighlight {
  if (json == null) {
    return json;
  }
  return {
    example: json['example'],
    note: json['note'],
    evidenceIndex: json['evidence_index'],
  };
}

export function EvidenceHighlightToJSON(value?: EvidenceHighlight | null): any {
  if (value == null) {
    return value;
  }
  return {
    example: value['example'],
    note: value['note'],
    evidence_index: value['evidenceIndex'],
  };
}
